"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xmg(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.25 14.655L16.1378 18.75H6.75V18.0653L11.8425 12.276L6.85275 5.994V5.25H16.101L16.4235 8.439H15.831C15.4402 7.71225 15.1088 7.1685 14.835 6.80775C14.562 6.447 14.3183 6.22275 14.1038 6.1335C13.9523 6.06 13.7438 6.0075 13.4783 5.976C13.1612 5.94111 12.8424 5.92483 12.5235 5.92725H9.89625L13.833 10.8322V11.0685L8.967 16.5922H14.5208C14.7937 16.5922 15.0443 16.527 15.2708 16.3973C15.4972 16.2668 15.6938 16.1032 15.8595 15.9067C16.0336 15.7036 16.1881 15.4844 16.3207 15.252C16.4628 15.0054 16.5876 14.7493 16.6943 14.4855L17.25 14.655Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.25 14.655L16.1378 18.75H6.75V18.0653L11.8425 12.276L6.85275 5.994V5.25H16.101L16.4235 8.439H15.831C15.4402 7.71225 15.1088 7.1685 14.835 6.80775C14.562 6.447 14.3183 6.22275 14.1038 6.1335C13.9523 6.06 13.7438 6.0075 13.4783 5.976C13.1612 5.94111 12.8424 5.92483 12.5235 5.92725H9.89625L13.833 10.8322V11.0685L8.967 16.5922H14.5208C14.7937 16.5922 15.0443 16.527 15.2708 16.3973C15.4972 16.2668 15.6938 16.1032 15.8595 15.9067C16.0336 15.7036 16.1881 15.4844 16.3207 15.252C16.4628 15.0054 16.5876 14.7493 16.6943 14.4855L17.25 14.655Z", fill: color }));
}
exports["default"] = xmg;
//# sourceMappingURL=xmg.js.map